import { CHAT_COPY, useChatUiStore } from '@/entities/chat'
import { BroadcastComposer } from './BroadcastComposer'
import { BroadcastRoster } from './BroadcastRoster'

export function BroadcastPane() {
  const selectedBroadcastId = useChatUiStore((state) => state.selectedBroadcastId)
  const composingBroadcast = useChatUiStore((state) => state.composingBroadcast)
  const selectBroadcast = useChatUiStore((state) => state.selectBroadcast)

  if (composingBroadcast) {
    return <BroadcastComposer onSent={(id) => selectBroadcast(id)} onCancel={() => selectBroadcast(null)} />
  }

  if (selectedBroadcastId != null) {
    return <BroadcastRoster broadcastId={selectedBroadcastId} onBack={() => selectBroadcast(null)} />
  }

  return (
    <div className="flex h-full items-center justify-center px-6 text-center text-[13px] text-ink-3">
      {CHAT_COPY.selectBroadcast}
    </div>
  )
}
